import { CommentDisplay } from './CommentDisplay';
import { NewComment } from './NewComment';
import React from 'react';
import { Skeleton } from 'antd';
export const CommentList = ({ data, initiativeId }) => React.createElement(Skeleton, { active: true, avatar: true, loading: !data },
    data && data.results.map((comment) => React.createElement(CommentDisplay, { comment: comment, key: comment.id })),
    React.createElement(NewComment, { initiativeId: initiativeId }));
